import { PipelineWidget } from "@/components/dashboard/PipelineWidget";
import { CRM_FUNIL_PARCERIA_PROSPECCAO } from "@/constants/crmFunil";

export default function PipelineParceiros() {
  return (
    <div className="space-y-4 sm:space-y-6 p-3 sm:p-4 md:p-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-4">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-foreground">CRM Parceiros</h1>
          <p className="text-sm sm:text-base text-muted-foreground">
            Prospecção de novas parcerias Sun7 — registros não aparecem na página Clientes
          </p>
        </div>
      </div>

      <div className="w-full overflow-x-auto">
        <PipelineWidget crmFunil={CRM_FUNIL_PARCERIA_PROSPECCAO} />
      </div>
    </div>
  );
}
